import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { AppPageTitleService } from '@infra-adapters/services/app-page-title.service';
import { iconSubset } from './icons/icon-subset';

@Component({
    selector: 'app-root',
    template: '<router-outlet />',
    imports: [RouterOutlet]
})
export class AppComponent {
  constructor(
    private readonly iconSetService: IconSetService,
    /** Activa la suscripción a rutas y el título del documento. */
    _pageTitle: AppPageTitleService,
  ) {
    this.iconSetService.icons = { ...iconSubset };
  }
}
